import rubricApi from '@/services/plataforma/rubric';

export default {
  actionGetAllRubrics({ commit, dispatch }, params) {
    return rubricApi.getAllRubrics(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetRubricById({ commit, dispatch }, params) {
    return rubricApi.getRubricById(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionDeleteRubricById({ commit }, id) {
    return rubricApi.deleteRubricById(id)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionCreateRubric({ commit }, params) {
    return rubricApi.createRubric(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionEditRubric({ commit }, params) {
    return rubricApi.editRubric(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  }
};
